import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loc } from 'redux-react-i18n';
import LazyLoad from 'react-lazyload';
import { routerActions } from 'connected-react-router';
import IconLive from 'components/mediabay-ui/components/IconLive';
import { Link } from 'react-router-dom';
import Button from 'components/mediabay-ui/components/Button';
import Media from 'react-media';
import isUzb from '../utils/checkCountry';
import Tabs from '../components/Tabs';
import Tab from '../components/Tabs/Tab';
import Slider from '../components/Slider';
import AdFoxBanner from '../components/Ads/AdFoxBanner';
import ChannelsCarousel from '../components/Carousels/ChannelsCarousel';
import MediasCarousel from '../components/Carousels/MediasCarousel';
import SimpleCarousel from '../components/Carousels/SimpleCarousel';
// import DoubleMediasCarousel from '../components/Carousels/DoubleMediasCarousel';
import * as slidersActions from '../actions/slidersActions';
import * as tvActions from '../actions/tvActions';
import * as radioActions from '../actions/radioActions';
import * as moviesActions from '../actions/moviesActions';
import * as serialsActions from '../actions/serialsActions';
import * as cartoonsActions from '../actions/cartoonsActions';
import * as clipsActions from '../actions/clipsActions';
import * as musicActions from '../actions/musicActions';
import * as podcastsActions from '../actions/podcastsActions';
// import * as audiobooksActions from '../actions/audiobooksActions';
import * as mediaDetailsActions from '../actions/mediaDetailsActions';
import * as audiosActions from '../actions/audiosActions';

class HomePage extends React.Component {
  static propTypes = {
    // Actions validation
    slidersActions: PropTypes.shape({
      getMainSlides: PropTypes.func,
      getCartoonsSlides: PropTypes.func,
      // getAudiobooksSlides: PropTypes.func,
    }).isRequired,

    tvActions: PropTypes.shape({
      getTv: PropTypes.func.isRequired,
    }).isRequired,

    radioActions: PropTypes.shape({
      getRadio: PropTypes.func.isRequired,
      setRadioPlayer: PropTypes.func.isRequired,
    }).isRequired,

    moviesActions: PropTypes.shape({
      getLastMovies: PropTypes.func.isRequired,
    }).isRequired,

    serialsActions: PropTypes.shape({
      getLastSerials: PropTypes.func.isRequired,
      getSerialEpisodes: PropTypes.func.isRequired,
    }).isRequired,

    cartoonsActions: PropTypes.shape({
      getLastCartoons: PropTypes.func.isRequired,
    }).isRequired,

    // clipsActions: PropTypes.shape({
    //   getLastClips: PropTypes.func.isRequired,
    //   getTopClips: PropTypes.func.isRequired,
    // }).isRequired,

    // musicActions: PropTypes.shape({
    //   getLastMusic: PropTypes.func.isRequired,
    //   getTopMusic: PropTypes.func.isRequired,
    // }).isRequired,

    podcastsActions: PropTypes.shape({
      getLastPodcasts: PropTypes.func.isRequired,
      getPodcastEpisodes: PropTypes.func.isRequired,
    }).isRequired,

    mediaDetailsActions: PropTypes.shape({
      getMediaDetails: PropTypes.func.isRequired,
      getAlbumDetails: PropTypes.func.isRequired,
      clearDetails: PropTypes.func.isRequired,
    }).isRequired,

    // audiobooksActions: PropTypes.shape({
    //   getLastAudiobooks: PropTypes.func.isRequired,
    // }).isRequired,

    audiosActions: PropTypes.shape({
      clearAudios: PropTypes.func,
    }).isRequired,

    // Data validation
    currentLanguage: PropTypes.string.isRequired,

    slidersData: PropTypes.shape({
      main: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.arrayOf(PropTypes.object),
      }),
      cartoons: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.arrayOf(PropTypes.object),
      }),

      // audioBooks: PropTypes.shape({
      //   status: PropTypes.number,
      //   data: PropTypes.arrayOf(PropTypes.object),
      // }),
    }).isRequired,

    tvChannelsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    radioChannelsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    moviesData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    serialsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    cartoonsData: PropTypes.shape({
      status: PropTypes.number,
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    // clipsData: PropTypes.shape({
    //   new: PropTypes.shape({
    //     status: PropTypes.number,
    //     data: PropTypes.arrayOf(PropTypes.object),
    //   }),
    //   top: PropTypes.shape({
    //     status: PropTypes.number,
    //     data: PropTypes.arrayOf(PropTypes.object),
    //   }),
    // }).isRequired,

    // musicData: PropTypes.shape({
    //   new: PropTypes.shape({
    //     status: PropTypes.number,
    //     data: PropTypes.arrayOf(PropTypes.object),
    //   }),
    //   top: PropTypes.shape({
    //     status: PropTypes.number,
    //     data: PropTypes.arrayOf(PropTypes.object),
    //   }),
    // }).isRequired,

    podcastsData: PropTypes.shape({
      new: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.arrayOf(PropTypes.object),
      }),
      top: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.arrayOf(PropTypes.object),
      }),
    }).isRequired,

    // audiobooksData: PropTypes.shape({
    //   status: PropTypes.number,
    //   data: PropTypes.arrayOf(PropTypes.object),
    // }).isRequired,

    audiosData: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.object),
    }).isRequired,

    contentDetails: PropTypes.shape({
      mediaDetails: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.objectOf(PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.number,
          PropTypes.string,
          PropTypes.array,
          PropTypes.object,
        ])),
      }),
      albumDetails: PropTypes.shape({
        status: PropTypes.number,
        data: PropTypes.objectOf(PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.number,
          PropTypes.string,
          PropTypes.array,
          PropTypes.object,
        ])),
      }),
    }).isRequired,
  }

  constructor() {
    super();

    this.radioChannelClickHandler = this.radioChannelClickHandler.bind(this);
    this.adContainer = React.createRef();
  }

  radioChannelClickHandler(e) {
    const { radioChannelsData, audiosData } = this.props;
    if (audiosData.data.length) {
      this.props.audiosActions.clearAudios();
    }

    // Firefox and Chrome get the e.target in different ways
    // Below the polyfill
    const radioId = e.target.parentNode.dataset.id || e.target.dataset.id;
    const selectedIndex = radioChannelsData.data.findIndex(radio => radio.id === +radioId);

    this.props.radioActions.setRadioPlayer({
      channels: radioChannelsData.data,
      mediaHost: radioChannelsData.mediaHost,
      selectedIndex,
    });
  }

  render() {
    const {
      currentLanguage,
      userData,
      slidersData,
      tvChannelsData,
      radioChannelsData,
      moviesData,
      serialsData,
      cartoonsData,
      // clipsData,
      podcastsData,
      // musicData,
      // audiobooksData,
      contentDetails,
    } = this.props;

    const isMobile = window.matchMedia('(max-width: 1024px)')

    return (
      <React.Fragment>
        {/* Main slider */}
        <Slider
          getSlides={this.props.slidersActions.getMainSlides}
          data={slidersData.main.data}
          accentColor="#ff2207"
          currentLanguage={currentLanguage}
          // adAvailable={false}
          adAvailable={isMobile.matches && !(userData.status === 200 && userData.data.data.vouchers.length)}
          {...(isMobile.matches ? { adContainer: <AdFoxBanner slot={2} /> } : {})}
          // {...(!isMobile.matches && !isUzb() ? { adContainer: <AdFoxBanner slot={5} /> } : {})}
        />

        {/* Channels tabs */}
        <Tabs activeTabIcon={<IconLive />} onClick>
          <Tab
            titleContent={(
              <Loc
                locKey="tv"
                style={{
                  margin: '0 10px -5px 65px',
                  fontSize: 25,
                }}
              />
            )}
            onClickWhenActive={() => this.props.routerActions.push('/tv')}
          >
            <ChannelsCarousel
              key="tv"
              type="tv"
              getChannels={this.props.tvActions.getTv}
              channelsData={tvChannelsData}
            />
          </Tab>
          <Tab
            titleContent={(
              <Loc
                locKey="radio"
                style={{
                  margin: '0 10px -5px 0',
                  fontSize: 25,
                }}
              />
            )}
            onClickWhenActive={() => this.props.routerActions.push('/radio')}
          >
            <ChannelsCarousel
              key="radio"
              type="radio"
              getChannels={this.props.radioActions.getRadio}
              channelsData={radioChannelsData}
              onItemClick={this.radioChannelClickHandler}
            />
          </Tab>

          <Media
            query="(min-device-width: 500px)"
            render={() => (
              <Link
                to="/tv"
                style={{ position: 'absolute', right: 25 }}
              >
                <Button>
                  <Loc locKey="watchAll" />
                </Button>
              </Link>
            )}
          />
        </Tabs>

        {/* Movies container */}
        <LazyLoad height={350} once debounce={50}>
          <MediasCarousel
            title={<Loc locKey="movies" />}
            buttonContent={<Loc locKey="watchAll" />}
            titleRoute="movies"
            itemRoute="movies/movie"
            getMedias={this.props.moviesActions.getLastMovies}
            getMediaDetails={this.props.mediaDetailsActions.getMediaDetails}
            mediasData={moviesData}
            mediaDetailsData={contentDetails.mediaDetails}
            currentLanguage={currentLanguage}
          />
        </LazyLoad>

        {/* New Serials container */}
        <LazyLoad height={350} once debounce={50}>
          <MediasCarousel
            title={<Loc locKey="serials" />}
            buttonContent={<Loc locKey="watchAll" />}
            titleRoute="serials/new"
            itemRoute="serials/serial"
            getMedias={this.props.serialsActions.getLastSerials}
            getMediaDetails={this.props.mediaDetailsActions.getAlbumDetails}
            clearDetails={this.props.mediaDetailsActions.clearDetails}
            mediasData={serialsData}
            mediaDetailsData={contentDetails.albumDetails}
            currentLanguage={currentLanguage}
          />
        </LazyLoad>

        {/* Cartoons section */}
        {isUzb() && (
          <React.Fragment>
            <LazyLoad height={450} once debounce={50}>
              <Slider
                getSlides={this.props.slidersActions.getCartoonsSlides}
                data={slidersData.cartoons.data}
                accentColor="#6ab"
                currentLanguage={currentLanguage}
              />
            </LazyLoad>

            <LazyLoad height={350} once debounce={50}>
              <SimpleCarousel
                title={<Loc locKey="cartoons" />}
                buttonContent={<Loc locKey="watchAll" />}
                titleRoute="cartoons"
                itemRoute="cartoons/cartoon"
                getMedias={this.props.cartoonsActions.getLastCartoons}
                mediasData={cartoonsData}
                currentLanguage={currentLanguage}
              />
            </LazyLoad>
          </React.Fragment>
        )}

        {/* Clips container */}
        {/* <LazyLoad height={500} once debounce={50}>
          <DoubleMediasCarousel
            title={<Loc locKey="clips" />}
            buttonContent={<Loc locKey="watchAll" />}
            titleRoute="clips"
            itemRoute="clips/clip"
            getMediasFirstRow={this.props.clipsActions.getLastClips}
            getMediasSecondRow={this.props.clipsActions.getTopClips}
            mediasDataFirstRow={clipsData.new}
            mediasDataSecondRow={clipsData.top}
            currentLanguage={currentLanguage}
          />
        </LazyLoad> */}

        {/* Music container */}
        {/* <LazyLoad height={500} once debounce={50}>
          <DoubleMediasCarousel
            title={<Loc locKey="music" />}
            buttonContent={<Loc locKey="watchAll" />}
            titleRoute="music"
            itemRoute="music/album"
            getMediasFirstRow={this.props.musicActions.getLastMusic}
            getMediasSecondRow={this.props.musicActions.getTopMusic}
            mediasDataFirstRow={musicData.new}
            mediasDataSecondRow={musicData.top}
            currentLanguage={currentLanguage}
          />
        </LazyLoad> */}

        <LazyLoad height={350} once debounce={50}>
          {/* Podcasts container */}
          <MediasCarousel
            title={<Loc locKey="podcasts" />}
            buttonContent={<Loc locKey="watchAll" />}
            titleRoute="podcasts/"
            itemRoute="podcasts/podcast"
            getMedias={this.props.podcastsActions.getLastPodcasts}
            getMediaDetails={this.props.mediaDetailsActions.getAlbumDetails}
            clearDetails={this.props.mediaDetailsActions.clearDetails}
            mediasData={podcastsData}
            mediaDetailsData={contentDetails.albumDetails}
            currentLanguage={currentLanguage}
            landscapeCover
          />
        </LazyLoad>


        {/* Audiobooks slider */}
        {/* <LazyLoad height={450} once debounce={50}>
          <Slider
            getSlides={this.props.slidersActions.getAudiobooksSlides}
            data={slidersData.audiobooks.data}
            accentColor="#a7c"
            currentLanguage={currentLanguage}
          />
        </LazyLoad> */}

        {/* Audiobooks container */}
        {/* {isUzb() && (
          <LazyLoad height={350} once debounce={50}>
            <SimpleCarousel
              title={<Loc locKey="audioBooks" />}
              buttonContent={<Loc locKey="watchAll" />}
              titleRoute="audiobooks"
              itemRoute="audiobooks/audiobook"
              getMedias={this.props.audiobooksActions.getLastAudiobooks}
              mediasData={audiobooksData}
              currentLanguage={currentLanguage}
            />
          </LazyLoad>
        )} */}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLanguage: state.i18n.currentLanguage,
    languages: state.i18n.dictionaries,
    userData: state.user.profileData,
    slidersData: state.sliders,
    tvChannelsData: state.tv.tvChannels,
    radioChannelsData: state.radio.radioChannels,
    moviesData: state.movies.last,
    serialsData: state.serials.last,
    cartoonsData: state.cartoons.last,
    clipsData: state.clips,
    musicData: state.music,
    podcastsData: state.podcasts.last,
    // audiobooksData: state.audiobooks.last,
    contentDetails: state.contentDetails,
    audiosData: state.audios,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    slidersActions: bindActionCreators(slidersActions, dispatch),
    tvActions: bindActionCreators(tvActions, dispatch),
    radioActions: bindActionCreators(radioActions, dispatch),
    moviesActions: bindActionCreators(moviesActions, dispatch),
    serialsActions: bindActionCreators(serialsActions, dispatch),
    cartoonsActions: bindActionCreators(cartoonsActions, dispatch),
    clipsActions: bindActionCreators(clipsActions, dispatch),
    musicActions: bindActionCreators(musicActions, dispatch),
    podcastsActions: bindActionCreators(podcastsActions, dispatch),
    // audiobooksActions: bindActionCreators(audiobooksActions, dispatch),
    mediaDetailsActions: bindActionCreators(mediaDetailsActions, dispatch),
    audiosActions: bindActionCreators(audiosActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
